export default {
  title: 'Zahlung',
  description: 'Alle Transaktionen sind sicher und verschlüsselt.',
  show_more_payment_methods: 'Weitere Zahlungsmethoden anzeigen',
  express_checkout_divider: 'oder',
};
